import axios from '../axios';
// 计量配置信息列表
export const getMeterConfigPage = data => {
  return axios({
    url: '/api/sys/meter/config/getMeterConfigPage',
    method: 'post',
    data
  })
};
// 计量配置信息列表修改
export const updateMeterConfig = data => {
  return axios({
    url: '/api/sys/meter/config/updateMeterConfig',
    method: 'post',
    data
  })
};
// 计量异常列表
export const getSysMeterErrPage = data => {
  return axios({
    url: '/api/sys/sys/meter/err/getSysMeterErrPage',
    method: 'post',
    data
  })
};
// 计量异常列表保存
export const saveSysMeterErr = data => {
  return axios({
    url: '/api/sys/sys/meter/err/saveSysMeterErr',
    method: 'post',
    data
  })
};
// 计量异常列表修改
export const updateSysMeterErr = data => {
  return axios({
    url: '/api/sys/sys/meter/err/updateSysMeterErr',
    method: 'post',
    data
  })
};
// 计量异常列表删除
export const deleteSysMeterErrs = data => {
  return axios({
    url: '/api/sys/sys/meter/err/deleteSysMeterErrs',
    method: 'post',
    data
  })
};
// 异常处理
export const exceptionHandling = data => {
  return axios({
    url: '/api/sys/sys/meter/err/exceptionHandling',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/MetrologyConfigurat.js